"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestUrl = void 0;
let RequestUrl = exports.RequestUrl = /*#__PURE__*/function (RequestUrl) {
  RequestUrl["AcceptNotification"] = "/system/ajax/Message/AcceptFailMessage";
  RequestUrl["AddBackorderDemand"] = "/system/ajax/ShoppingBag/AddBackorderDemand";
  RequestUrl["AddBasketOffer"] = "/system/ajax/Offer/ApplyBasketOffer";
  RequestUrl["AddCatalogueOffer"] = "/system/ajax/Offer/ApplyCatalogueOffer";
  RequestUrl["AddCustomerOrder"] = "/system/ajax/EndConsumerOrder/ApproveOrders";
  RequestUrl["AddFreeShippingOffer"] = "/system/ajax/Delivery/AddFreeShippingItem";
  RequestUrl["AddToBasketCheckLoyalty"] = "/system/ajax/ShoppingBag/AddToShoppingBagItemAndCheckLoyalty";
  RequestUrl["AddToBasketForMoney"] = "/system/ajax/ShoppingBag/AddOrUpdateShoppingBagItem";
  RequestUrl["AddToBasketForPoints"] = "/system/ajax/Offer/AddOfferItem";
  RequestUrl["AddToBasketForPointsRewardShop"] = "/system/ajax/Offer/RedeemLoyaltyPoints";
  RequestUrl["AddVoucher"] = "/system/ajax/ShoppingBag/AddVoucher";
  RequestUrl["CancelBackorderDemand"] = "/system/ajax/ShoppingBag/CancelBackorderDemand";
  RequestUrl["CancelSubscription"] = "/system/ajax/ShoppingBag/CancelSubscription";
  RequestUrl["ClearBasket"] = "/system/ajax/ShoppingBag/RemoveAllShoppingBagItems";
  RequestUrl["DelaySubscription"] = "/system/ajax/ShoppingBag/DelaySubscription";
  RequestUrl["GetShoppingContext"] = "/system/ajax/ShoppingBag/GetShoppingContext";
  RequestUrl["PurchaseBasketOffer"] = "/system/ajax/Offer/PurchaseBasketOffer";
  RequestUrl["RemoveBasketItem"] = "/system/ajax/ShoppingBag/RemoveShoppingBagItem";
  RequestUrl["RemoveCustomerOrder"] = "/system/ajax/EndConsumerOrder/UnapproveOrder";
  RequestUrl["RemoveVoucher"] = "/system/ajax/ShoppingBag/RemoveVoucher";
  RequestUrl["ReplaceShoppingBagItem"] = "/system/ajax/ShoppingBag/ReplaceShoppingBagItem";
  RequestUrl["ResetFreeShippingSelection"] = "/system/ajax/Delivery/ResetFreeShippingSelection";
  RequestUrl["UpdateBasketItem"] = "/system/ajax/ShoppingBag/UpdateShoppingBagItem";
  RequestUrl["UpdateCustomerOrderItem"] = "/system/ajax/EndConsumerOrder/UpdateEndConsumerOrderItem";
  RequestUrl["UpdateDeliveryAddress"] = "/system/ajax/DeliverySelection/UpdateDeliveryAddress";
  RequestUrl["UpdateDeliveryChannel"] = "/system/ajax/DeliverySelection/UpdateDeliveryChannel";
  RequestUrl["UpdateDonation"] = "/system/ajax/Donation/UpdateDonation";
  RequestUrl["UpdateOfferItem"] = "/system/ajax/Offer/UpdateOfferItem";
  RequestUrl["UpdateOfferItems"] = "/system/ajax/Offer/UpdateOfferItems";
  RequestUrl["UpdatePaymentProvider"] = "/system/ajax/Payment/UpdatePaymentProvider";
  return RequestUrl;
}({});
